export default __webpack_public_path__ + "static/winter16-ca01a2b5547f61255a39b796151b57d7.webp";